package com.arena_web.ui.components.widgets

import androidx.compose.runtime.Composable
import com.arena_web.ui.theme.AppGradients
import com.arena_web.ui.utils.sBorderRadius
import com.arena_web.ui.utils.sHeight
import com.arena_web.ui.utils.sWidth
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.styleModifier

@Composable
fun SlotBar(
    filled: Boolean = false,
    modifier: Modifier = Modifier
) {
    Box(
        modifier
            .sWidth(28)
            .sHeight(6)
            .sBorderRadius(4)
            .styleModifier {
                property("background", AppGradients.InteractiveSecondary)
                property("overflow", "clip")
            }
    ) {
        if (filled) {
            Box(
                Modifier
                    .fillMaxSize()
                    .sBorderRadius(4)
                    .styleModifier {
                        property("background", "linear-gradient(to bottom, #7BFA6F, rgba(73, 148, 66, 0))")
                    }
            )
        }
    }
}
